import React, { useState, useEffect } from 'react';
import { RESTAURANT_API_PATHS } from '../constants/apiPaths';
import axiosRestaurantInstance from './AxiosRestaurantInstance';
import './css/Pickup.css';

const Pickup = () => {
  const [restaurants, setRestaurants] = useState([]);
  const [selectedRestaurant, setSelectedRestaurant] = useState('');
  const [orders, setOrders] = useState([]);

  const user = JSON.parse(localStorage.getItem('user'));
  const userId = user ? user.userId : null;

  useEffect(() => {
    const fetchRestaurants = async () => {
      if (!userId) {
        console.error('User ID is not available');
        return;
      }

      try {
        const response = await axiosRestaurantInstance.get(RESTAURANT_API_PATHS.userRestaurants(userId));
        setRestaurants(Array.isArray(response.data) ? response.data : []);
      } catch (error) {
        console.error('Error fetching restaurants:', error.response?.data || error.message);
      }
    };

    fetchRestaurants();
  }, [userId]);

  const handleRestaurantChange = async (event) => {
    const restaurantId = event.target.value;
    setSelectedRestaurant(restaurantId);

    try {
      const response = await axiosRestaurantInstance.get(
        RESTAURANT_API_PATHS.restaurantPickupOrdersByRestaurantId(restaurantId)
      );
      setOrders(response.data.data || []);
    } catch (error) {
      console.error('Error fetching pickup orders:', error.response?.data || error.message);
      setOrders([]); // Clear orders on error
    }
  };

  const handleAcceptOrder = async (orderId) => {
    try {
      await axiosRestaurantInstance.put(`/accept_order/${orderId}`);
      setOrders((prevOrders) =>
        prevOrders.map((order) =>
          order.Pickup_Id === orderId ? { ...order, Pickup_status: 'accepted' } : order
        )
      );
    } catch (error) {
      console.error('Error accepting order:', error.response?.data || error.message);
    }
  };

  return (
    <div className="pickup-container">
      <h3>Select a Restaurant for Pickup</h3>
      <form>
        <div>
          <label htmlFor="restaurant">Restaurant:</label>
          <select
            className="today-order-select"
            value={selectedRestaurant}
            onChange={handleRestaurantChange}
          >
            <option value="">-- Select a restaurant --</option>
            {restaurants.length > 0 ? (
              restaurants.map((restaurant) => (
                <option key={restaurant.RestaurantId} value={restaurant.RestaurantId}>
                  {restaurant.RestaurantName}
                </option>
              ))
            ) : (
              <option disabled>No restaurants available</option>
            )}
          </select>
        </div>
      </form>

      {selectedRestaurant && (
        <div className="orders-container">
          <h3>Pickup Orders</h3>
          <table className="orders-table">
            <thead>
              <tr>
                <th>Pickup Location</th>
                <th>Destination</th>
                <th>No of Items</th>
                <th>Notes</th>
                <th>Status</th>
                <th>Price</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {orders.map((order) => (
                <tr key={order.Pickup_Id}>
                  <td>{order.Pickup_Location}</td>
                  <td>{order.Destination}</td>
                  <td>{order.No_of_items}</td>
                  <td>{order.Notes || 'No notes'}</td>
                  <td>{order.Pickup_status}</td>
                  <td>{order.Total_Price ? `$${order.Total_Price}` : 'N/A'}</td>
                  <td>
                    {order.Pickup_status === 'pending' && (
                      <button onClick={() => handleAcceptOrder(order.Pickup_Id)}>Accept</button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default Pickup;
